// extracted by mini-css-extract-plugin
export default {"root":"_1Wqhx","centerInPage":"_2yPVx","centerInParent":"_37p2N","dots":"_1igrN","animatedDots":"_2OTsz"};